import ProLiteIndicator from './ProLiteIndicator'

export default ProLiteIndicator
